module.exports = __webpack_public_path__ + "static/media/light_green_star.249ca1e8.png";